import { render, staticRenderFns } from "./MatrizPeligros.vue?vue&type=template&id=5a259713&scoped=true&"
import script from "./MatrizPeligros.vue?vue&type=script&lang=js&"
export * from "./MatrizPeligros.vue?vue&type=script&lang=js&"
import style0 from "./MatrizPeligros.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MatrizPeligros.vue?vue&type=style&index=1&id=5a259713&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a259713",
  null
  
)

export default component.exports